import React from 'react';
import { motion } from 'framer-motion';
import webDesignIcon from '../../assets/images/webDesignIcon.jpg';
import brandStrategyIcon from '../../assets/images/brandStrategyIcon.jpg';
import maintenanceIcon from '../../assets/images/maintenanceIcon.jpg';
import '../../assets/styles/ServicesSection.css';

const services = [
  {
    title: 'Web Design',
    description: 'Visually stunning, user-friendly websites tailored to your brand and goals. From intuitive layouts to SEO-ready designs, your site will stand out.',
    icon: webDesignIcon,
  },
  {
    title: 'Brand Strategy',
    description: 'A cohesive brand identity that connects with your audience from color palette and typography to defining your unique brand voice and values.',
    icon: brandStrategyIcon,
  },
  {
    title: 'Website Maintenance',
    description: 'Ongoing updates, security patches, and performance improvements so you can focus on growing your business worry-free.',
    icon: maintenanceIcon,
  },
];

const ServicesSection = () => (
  <motion.section
    id="services"
    className="services-section section alt"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: 'easeOut' }}
    viewport={{ once: true, amount: 0.1 }}
  >
    <div className="section-inner">
      <p className="eyebrow centered">What we do</p>
      <h2 className="centered">Services</h2>
      <p className="intro centered">
        Everything your business needs to build a powerful online presence, designed and delivered end to end.
      </p>

      <div className="services-grid">
        {services.map((service, i) => (
          <motion.div
            key={service.title}
            className="service-card"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 + i * 0.12 }}
            viewport={{ once: true, amount: 0.1 }}
          >
            <img className="service-icon" src={service.icon} alt={service.title} />
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </motion.section>
);

export default ServicesSection;
